// The site theme lives on <html data-theme>. The server prints it from the
// player's saved choice (services\theme\SiteTheme); this switches it in place
// after the player picks another one, without a reload.
export const THEME_DARK = 'dark';
export const THEME_LIGHT = 'light';

// Mirrors SiteTheme::browserBarColor().
const BROWSER_BAR_COLORS = {
	[THEME_DARK]: '#323232',
	[THEME_LIGHT]: '#e9edf2',
};

export function applySiteTheme(theme) {
	const root = document.documentElement;
	if(theme === THEME_LIGHT) {
		root.setAttribute('data-theme', THEME_LIGHT);
	}
	else {
		root.removeAttribute('data-theme');
	}
	const browserBar = document.querySelector('meta[name="theme-color"]');
	if(browserBar) {
		browserBar.setAttribute('content', BROWSER_BAR_COLORS[theme] || BROWSER_BAR_COLORS[THEME_DARK]);
	}
}
